import { request } from "../utils/request.js"

export const commodityQuantityDetail_findPageByCommodity = (pojo, args) => request({
    url: 'commodityQuantityDetail/findPageByCommodity',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityQuantityDetail_findById = (id, args) => request({
    url: 'commodityQuantityDetail/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/commodityQuantityDetail.js